var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item-avatar',[_c('v-progress-circular',{attrs:{"value":_vm.getValue,"rotate":_vm.circularRotate,"color":_vm.$options.filters.colorByPercentage(_vm.getValue)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }